const VariousIcon = ({ height = '50px', width = '50px' }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 50 51"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.6425 5.60873C17.8188 5.48467 18.0438 5.466 18.235 5.55671C21.67 7.16548 23.89 10.7886 23.89 14.7865C23.89 17.3768 22.9435 19.7986 21.3495 21.6275L21.0925 21.9113L26.6508 21.913L26.9427 21.9303L27.2036 21.9582L27.5101 22.0046L27.8558 22.0741C28.764 22.2805 29.9808 22.747 31.0609 23.7993L31.275 24.0176L35.7987 28.4371L41.7663 30.1499C41.81 30.1619 41.8513 30.1806 41.8925 30.2033L42.0895 30.3211L42.3106 30.4697C42.8896 30.8799 43.8518 31.7289 43.9776 32.9018L43.9912 33.158V37.9057C44.6 38.3712 45 39.1276 45 39.9853C45 41.1328 44.1709 42.078 43.1175 42.1743L42.94 42.1824H39.705C39.135 44.0993 37.4712 45.5 35.4888 45.5C33.5901 45.5 31.9829 44.2136 31.3506 42.4193L31.2737 42.1824H18.46C17.9925 44.086 16.3825 45.5 14.455 45.5C12.2305 45.5 10.4066 43.6327 10.2874 41.2886L10.2812 41.0445V23.8295C7.05875 22.1394 5 18.6364 5 14.7865C5 10.7886 7.22 7.16548 10.655 5.55671C10.8475 5.46733 11.0713 5.48601 11.2475 5.60873C11.3954 5.71211 11.4939 5.87479 11.5226 6.0566L11.5312 6.16767V13.1297H17.3588V6.16767C17.3588 5.94223 17.465 5.73279 17.6425 5.60873ZM26.8226 31.8573C27.1676 31.8573 27.4476 32.1561 27.4476 32.5242C27.4476 32.8515 27.2264 33.124 26.9349 33.1805L26.8226 33.1912H25.7139C25.3676 33.1912 25.0889 32.8924 25.0889 32.5242C25.0889 32.197 25.3091 31.9245 25.6012 31.868L25.7139 31.8573H26.8226ZM22.9987 25.9558H18.6074V29.2828H22.9987V25.9558ZM25.9727 25.9562L24.249 25.9558V29.2828H30.7478L29.2059 27.657C29.0725 27.5154 28.94 27.3747 28.8103 27.2365C28.1782 26.562 27.393 26.2423 26.8068 26.091L26.532 26.0285L26.3001 25.989L26.0543 25.9612L25.9727 25.9562Z"
      fill="#333333"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M35.4887 37.3494C33.7274 37.3494 32.2949 38.8781 32.2949 40.7577C32.2949 42.6373 33.7274 44.166 35.4887 44.166C37.2499 44.166 38.6824 42.6373 38.6824 40.7577C38.6824 38.8781 37.2499 37.3494 35.4887 37.3494Z"
      fill="#8F8FAB"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M40.8086 31.2572C40.9964 31.927 41.4565 32.8176 42.5079 33.3705L42.7423 33.4836V33.1581C42.7423 32.5029 42.037 31.8713 41.5773 31.5513L41.3723 31.4186L40.8086 31.2572Z"
      fill="#EDFF91"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M42.5992 38.7581H39.5029C39.7704 39.3677 39.9317 40.0413 39.9317 40.7577L39.9229 40.8484H42.9392C43.3854 40.8484 43.7492 40.4615 43.7492 39.9853C43.7492 39.3573 43.304 38.8374 42.733 38.7663L42.5992 38.7581Z"
      fill="#01ABC4"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M31.4737 38.7581H18.6074V40.8484H31.0524L31.0437 40.7577C31.0437 40.1437 31.1621 39.561 31.3652 39.0232L31.4737 38.7581Z"
      fill="#01ABC4"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M22.9987 30.6169H18.6074V37.4241H22.9987V30.6169Z"
      fill="#B4CFEC"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M26.5371 23.2454L19.5487 23.2452C19.3462 23.3839 19.1414 23.5203 18.9301 23.6472L18.6074 23.8295V24.6219L26.0269 24.6236L26.2429 24.6393C26.2745 24.6424 26.3086 24.6461 26.3449 24.6504L26.5883 24.685L26.8773 24.7401C27.6501 24.9077 28.7757 25.3129 29.6937 26.2933L32.7149 29.4722C32.8962 29.6616 32.9524 29.9498 32.8574 30.2019C32.7749 30.4168 32.5951 30.5681 32.3856 30.6069L32.2787 30.6168H24.2487V37.424H32.2787L32.3249 37.4334C33.1324 36.5596 34.2499 36.0154 35.4874 36.0154C36.7312 36.0154 37.8524 36.5663 38.6599 37.4467L38.7116 37.4324L38.7662 37.424H42.5987L42.6698 37.4299L42.7399 37.4387V34.8988C40.5262 34.1753 39.6728 32.3221 39.4702 31.0313L39.4474 30.8662L35.3249 29.683C35.2608 29.6643 35.1994 29.6349 35.1437 29.5965L35.0649 29.5322L30.4099 24.9807C29.3753 23.8783 28.1314 23.4762 27.3288 23.3295L27.0497 23.2856C27.0071 23.28 26.9665 23.2752 26.9281 23.271L26.7254 23.2532L26.5371 23.2454Z"
      fill="#B4CFEC"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18.6088 7.25617V13.4178C18.6088 13.9461 18.2401 14.3847 17.7617 14.4541L17.6287 14.4637H11.2612C10.7651 14.4637 10.3551 14.0691 10.2902 13.5595L10.2812 13.4178V7.25617C7.80375 8.81693 6.25 11.6703 6.25 14.7865C6.25 18.2548 8.17625 21.3977 11.1575 22.7943C11.3514 22.8858 11.4875 23.0753 11.5224 23.2939L11.5312 23.4053V41.0445C11.5312 42.7653 12.8425 44.166 14.455 44.166C15.9895 44.166 17.2497 42.8894 17.352 41.279L17.3588 41.0672V23.4053C17.3588 23.1412 17.505 22.9011 17.7325 22.7943C20.7137 21.3977 22.64 18.2548 22.64 14.7865C22.64 11.7857 21.1992 9.02865 18.8802 7.43486L18.6088 7.25617Z"
      fill="#FCD385"
    />
    <path
      d="M16.0029 40.717C16.0029 41.6011 15.3314 42.3178 14.5029 42.3178C13.6745 42.3178 13.0029 41.6011 13.0029 40.717C13.0029 39.8329 13.6745 39.1162 14.5029 39.1162C15.3314 39.1162 16.0029 39.8329 16.0029 40.717Z"
      fill="#333333"
    />
    <ellipse cx="14.5039" cy="40.7171" rx="0.75" ry="0.800387" fill="white" />
    <path
      d="M36.999 40.717C36.999 41.6011 36.3275 42.3178 35.499 42.3178C34.6706 42.3178 33.999 41.6011 33.999 40.717C33.999 39.8329 34.6706 39.1162 35.499 39.1162C36.3275 39.1162 36.999 39.8329 36.999 40.717Z"
      fill="#333333"
    />
    <ellipse cx="35.5" cy="40.7171" rx="0.75" ry="0.800387" fill="white" />
  </svg>
);

export default VariousIcon;
